<template>
  <main-template>
    <v-row class="mb-2">
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          {{ modoEdicao ? "Editar Justificativa" : "Justificar Falta" }}
        </h1>
        <p class="body-2 ml-8 mb-0">
          {{
            modoEdicao
              ? "Atualize os dados da sua justificativa."
              : "Registre uma justificativa para a sua falta."
          }}
        </p>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-title class="subtitle-1 font-weight-bold">Dados da justificativa</v-card-title>
      <v-divider />
      <v-card-text class="pt-5">
        <v-form ref="formRef">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                :value="user && user.name"
                label="Colaborador"
                outlined
                dense
                readonly
                background-color="grey lighten-4"
              />
            </v-col>

            <v-col cols="12" sm="6">
              <v-menu
                v-model="menuDataInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    :value="form.data_inicio ? formatarData(form.data_inicio) : ''"
                    label="Data de início *"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    :rules="[() => !!form.data_inicio || 'Data de início obrigatória']"
                  />
                </template>
                <v-date-picker
                  v-model="form.data_inicio"
                  locale="pt-BR"
                  :max="hoje"
                  @input="menuDataInicio = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6">
              <v-menu
                v-model="menuDataFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    :value="form.data_fim ? formatarData(form.data_fim) : ''"
                    label="Data de fim"
                    outlined
                    dense
                    readonly
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    hint="Deixe em branco se for apenas um dia"
                    persistent-hint
                    :rules="[() => validarDataFim()]"
                  />
                </template>
                <v-date-picker
                  v-model="form.data_fim"
                  locale="pt-BR"
                  :min="form.data_inicio || undefined"
                  :max="hoje"
                  @input="menuDataFim = false"
                />
              </v-menu>
            </v-col>

            <v-col v-if="form.data_inicio" cols="12">
              <div class="caption mb-3">
                <span v-if="form.data_fim && form.data_fim >= form.data_inicio">
                  Cobrindo {{ totalDias }} dia{{ totalDias !== 1 ? "s" : "" }}:
                  {{ formatarData(form.data_inicio) }} até {{ formatarData(form.data_fim) }}
                </span>
                <span v-else>Apenas {{ formatarData(form.data_inicio) }}</span>
              </div>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.motivo"
                :items="motivos"
                label="Motivo *"
                outlined
                dense
                :rules="[(v) => !!v || 'Motivo obrigatório']"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-if="form.motivo === 'Outros'"
                v-model="form.observacao"
                label="Descreva o motivo *"
                outlined
                dense
                rows="3"
                counter="500"
                :rules="[
                  (v) => !!v || 'Descrição obrigatória quando motivo é Outros',
                  (v) => !v || v.length <= 500 || 'Máximo 500 caracteres',
                  validarTexto,
                ]"
              />
              <v-textarea
                v-else
                v-model="form.observacao"
                label="Observação (opcional)"
                outlined
                dense
                rows="3"
                counter="500"
                :rules="[(v) => !v || v.length <= 500 || 'Máximo 500 caracteres', validarTexto]"
              />
            </v-col>

            <v-col cols="12">
              <v-file-input
                v-model="form.documento"
                :label="
                  modoEdicao
                    ? 'Substituir documento (opcional)'
                    : 'Anexar documento (PDF, JPEG, PNG)'
                "
                outlined
                dense
                show-size
                accept=".pdf,.jpg,.jpeg,.png"
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                clearable
                :rules="[validarArquivo]"
              />
              <p
                v-if="modoEdicao && temDocumentoExistente && !form.documento"
                class="caption mt-1 mb-0"
              >
                Documento atual mantido. Selecione um arquivo para substituí-lo.
              </p>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />
      <v-card-actions class="px-4 py-3">
        <v-spacer />
        <v-btn text :disabled="enviando" @click="$router.go(-1)">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="enviando"
          :disabled="!podeEnviar || enviando"
          @click="enviar"
        >
          <v-icon left small>mdi-send</v-icon>
          {{ modoEdicao ? "Salvar Alterações" : "Enviar Justificativa" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import { MOTIVOS_COLABORADORES } from "@/plugins/motivos_colaboradores";

export default {
  name: "NovaFaltaJustificadaPage",
  data() {
    return {
      enviando: false,
      carregando: false,
      motivos: MOTIVOS_COLABORADORES,
      menuDataInicio: false,
      menuDataFim: false,
      modoEdicao: false,
      editarId: null,
      temDocumentoExistente: false,
      form: {
        data_inicio: "",
        data_fim: "",
        motivo: "",
        observacao: "",
        documento: null,
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    hoje() {
      return new Date().toISOString().slice(0, 10);
    },
    totalDias() {
      if (!this.form.data_inicio || !this.form.data_fim) return 1;
      const inicio = new Date(this.form.data_inicio);
      const fim = new Date(this.form.data_fim);
      if (fim < inicio) return 1;
      return Math.round((fim - inicio) / 86400000) + 1;
    },
    podeEnviar() {
      if (!this.form.data_inicio) return false;
      if (!this.form.motivo) return false;
      if (this.form.motivo === "Outros" && !this.form.observacao?.trim()) return false;
      if (this.form.data_fim) {
        if (this.form.data_fim < this.form.data_inicio) return false;
        if (this.form.data_fim > this.hoje) return false;
      }
      if (this.form.observacao && this.validarTexto(this.form.observacao) !== true) return false;
      if (this.form.documento && this.validarArquivo(this.form.documento) !== true) return false;
      return true;
    },
  },
  async created() {
    const editarId = this.$route.query.editarId;
    if (editarId) {
      this.modoEdicao = true;
      this.editarId = editarId;
      await this.carregarParaEdicao(editarId);
    }
  },
  methods: {
    async carregarParaEdicao(id) {
      try {
        this.carregando = true;
        const falta = await this.$services.colaboradorPontosService.buscarFaltaJustificada(id);
        this.form = {
          data_inicio: String(falta.data_inicio).split("T")[0],
          data_fim: falta.data_fim ? String(falta.data_fim).split("T")[0] : "",
          motivo: falta.motivo,
          observacao: falta.observacao || "",
          documento: null,
        };
        this.temDocumentoExistente = !!falta.documento;
      } catch (error) {
        this.$handleError(error);
        this.$router.go(-1);
      } finally {
        this.carregando = false;
      }
    },
    formatarData(data) {
      if (!data) return "";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
    validarDataFim() {
      const v = this.form.data_fim;
      if (!v) return true;
      if (this.form.data_inicio && v < this.form.data_inicio)
        return "A data de fim deve ser igual ou posterior ao início";
      if (v > this.hoje) return "A data de fim não pode ser futura";
      return true;
    },
    validarTexto(v) {
      if (!v) return true;
      if (/\p{Emoji_Presentation}/u.test(v)) return "Emojis não são permitidos";
      if (/[<>{}[\]\\|^~`]/u.test(v)) return "Caracteres especiais não são permitidos";
      return true;
    },
    validarArquivo(file) {
      if (!file) return true;
      const tiposPermitidos = ["application/pdf", "image/jpeg", "image/png"];
      if (!tiposPermitidos.includes(file.type)) return "Apenas PDF, JPG ou PNG são permitidos";
      if (file.size > 10 * 1024 * 1024) return "Arquivo excede 10 MB";
      return true;
    },
    async enviar() {
      if (!this.$refs.formRef.validate()) return;

      const formData = new FormData();
      formData.append("data_inicio", this.form.data_inicio);
      if (this.form.data_fim && this.form.data_fim >= this.form.data_inicio) {
        formData.append("data_fim", this.form.data_fim);
      }
      formData.append("motivo", this.form.motivo);
      if (this.form.observacao) formData.append("observacao", this.form.observacao);
      if (this.form.documento) formData.append("documento", this.form.documento);

      try {
        this.enviando = true;
        if (this.modoEdicao) {
          await this.$services.colaboradorPontosService.atualizarMinhaFaltaJustificada(
            this.editarId,
            formData
          );
          this.$toast.success("Justificativa atualizada com sucesso!");
        } else {
          await this.$services.colaboradorPontosService.enviarFaltaJustificada(formData);
          this.$toast.success("Justificativa enviada com sucesso!");
        }
        this.$router.push({ name: "colaboradores.faltasJustificadas" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>
